<template>
    <!-- <div :class="!info.officialJoined ? 'unOfficialJoinedBg' : ''"> -->
    <div :class="!$root.officialJoinedStyle ? 'unOfficialJoinedBg' : ''">
        <div class="commodity-info-module">
            <div v-if="!!proInfo.is_lowest_price" class="top-info-lowestIcon">
                <img
                    :src="lowestIcon" alt=""
                    class="lowestIcon"
                >
            </div>
            <div class="top-info">
                <div class="info-left">
                    <div class="price">
                        {{ proInfo.real_price_prefix }}
                        <div
                            class="yuan"
                            :style="{color: proInfo.is_tieba_vip && proInfo.show_vip_price ? '#FFD27A' : '#ffffff'}"
                        >￥</div>
                        <div
                            class="now-price"
                            :style="{color: proInfo.is_tieba_vip && proInfo.show_vip_price ? '#FFD27A' : '#ffffff'}"
                        >
                            {{ initPrice(realPrice) }}
                        </div>
                        <img
                            v-if="proInfo.is_tieba_vip && proInfo.show_vip_price" :src="vipIcon"
                            class="vip-icon"
                        >
                        <div v-if="originalPrice" class="original-price">
                            <span>¥</span>{{ String(originalPrice).slice(0, -2) }}
                        </div>
                        <div
                            v-if="!proInfo.is_tieba_vip && proInfo.show_vip_price
                                && proInfo.vip_price_info.total_price !== proInfo.normal_price_info.real_price"
                            class="tieba-vip--price"
                        >
                            <span>¥</span>{{ initPrice(proInfo.vip_price_info.total_price) }}
                        </div>
                        <img
                            v-if="!proInfo.is_tieba_vip && proInfo.show_vip_price
                                && proInfo.vip_price_info.total_price !== proInfo.normal_price_info.real_price"
                            :src="vipIcon"
                            class="vip-icon"
                        >
                    </div>
                    <div class="discount">
                        <span
                            v-for="(item,index) of proInfo.tab_desc" :key="index"
                            class="discount-content"
                        >{{ item }}</span>
                    </div>
                    <div v-if="proInfo.sold_count > 0" class="sales-num">已售{{ soldCount }}</div>
                </div>
                <!-- 结束倒计时，品专不展示 -->
                <div
                    v-if="isShowCountDown && !isSem"
                    class="info-right"
                    :style="{'margin-left': String(proInfo.real_price).length >= 5 ? '-5vw' : ''}"
                >
                    <div class="count-down-text">
                        <span class="light-icon"><img
                            class="lightning" src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211026/1635238779216179.png"
                            alt=""
                        ></span>
                        <span>距结束还剩</span>
                    </div>
                    <div class="count-down">
                        <span class="box"><span class="hour">{{ days }}</span><span class="text">天</span></span>
                        <span class="colon"><img src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211111/1636616777587304.png" alt=""></span>
                        <span class="box"><span class="hour">{{ hours }}</span><span class="text">时</span></span>
                        <span class="colon"><img src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211111/1636616777587304.png" alt=""></span>
                        <span class="box"><span class="hour">{{ minutes }}</span><span class="text">分</span></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 一句话描述 -->
        <div class="bottom-info">
            <div class="notice">{{ proInfo.desc }}</div>
            <!-- <div class="shop">{{ shop_name }}</div> -->
        </div>
        <div
            v-if="showTibeVipGuide"
            class="tibe-vip-guide" :style="{backgroundImage: `url(${vipGuideBg})`}"
            @click="showVipPanel"
        >
            <img :src="vipGuideIcon" class="icon">
            <!-- eslint-disable vue/no-v-html -->
            <!--bca-disable-->
            <div v-html="proInfo.tieba_vip_bars"></div>
            <img :src="vipGuideRight" class="right">
        </div>
    </div>
</template>

<script>
import LowestIcon from 'public/assets/imgs/productinfo_lowest.png';
import vipGuideBg from 'public/assets/imgs/zone/vip-guide-bg.png';
import vipGuideIcon from 'public/assets/imgs/zone/vip-guide-icon.png';
import vipGuideRight from 'public/assets/imgs/zone/vip-guide-right.png';
import {getQueryString} from '@/utils/url';
import vipIcon from 'public/assets/imgs/my-coupons/vip-price-tag.png';

export default {
    props: {
        proInfo: {
            type: Object,
            required: true,
        },
        info: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            // real_price: 213,
            // original_price: 320,
            // activity_tab_desc: ['全款立减30','5元预约抵扣券','抽免单','抽免单','抽免单','抽免单'],
            // sold_count: 10000,
            // desc: '官方补贴30元，随机可享超值免单!',
            // 倒计时天、时、分
            days: '00',
            hours: '00',
            minutes: '00',
            // 是否展示倒计时
            isShowCountDown: false,
            // 品专
            isSem: false,
            lowestIcon: LowestIcon,
            vipGuideBg,
            vipGuideIcon,
            vipGuideRight,
            vipIcon: vipIcon,
        };
    },
    computed: {
        // 销售量处理：1.小于0不显示销量 2、1-1000直接展示数字  3、1000以上展示 1000+
        soldCount() {
            if (this.proInfo.sold_count <= 0) {
                return '';
            }
            else if (this.proInfo.sold_count >= 1 && this.proInfo.sold_count <= 1000) {
                return this.proInfo.sold_count;
            }
            return '1000+';

        },
        realPrice() {
            if (this.proInfo.is_tieba_vip) {
                return this.proInfo.vip_price_info.real_price;
            }
            return this.proInfo.normal_price_info.real_price;
        },
        originalPrice() {
            if (this.proInfo.is_tieba_vip) {
                return this.proInfo.vip_price_info.price;
            }
            return this.proInfo.normal_price_info.price;
        },
        showTibeVipGuide() {
            if (this.proInfo.is_show_bar) {
                return true;
            }
            return false;
        },
    },
    created() {
        this.isSem = getQueryString('from') === 'sem';
        // 倒计时
        this.setInterval(this.proInfo.end_time);
        if (this.proInfo.tieba_vip_status === 1 && this.proInfo.vip_price_info?.discount_list.length > 0) {
            this.$root.sendLog('display', 'tibeVipGuide_display');
        }
    },
    methods: {
        // 距离结束倒计时
        setInterval(endTime) {
            const now = Math.round(new Date() / 1000);
            if (now < endTime) {
                this.isShowCountDown = true;
                const leftTime = endTime - now;
                this.days = Math.floor(leftTime / (60 * 60 * 24));
                this.hours = Math.floor((leftTime % (60 * 60 * 24)) / (60 * 60));
                this.minutes = Math.floor((leftTime % (60 * 60)) /  60);
                if (String(this.days).length < 2 || String(this.hours).length < 2 || String(this.minutes).length < 2) {
                    this.days = (Array(2).join(0) + this.days).slice(-2);
                    this.hours = (Array(2).join(0) + this.hours).slice(-2);
                    this.minutes = (Array(2).join(0) + this.minutes).slice(-2);
                }
            }
            else {
                this.isShowCountDown = false;
            }
        },
        showVipPanel() {
            this.$root.isShowVipPanel = true;
            this.$root.sendLog('click', 'tiebaVipGuide_click');
        },
        initPrice(price) {
            const priceStr = price.toString();
            if (priceStr.slice(-2) === '00' && price !== 0) {
                return priceStr.slice(0, -2);
            }
            else if (price === 0) {
                return 0;
            }
            else if (priceStr[priceStr.length - 1] === '0') {
                return Number(price * 0.01).toFixed(1);
            }
            return Number(price * 0.01).toFixed(2);
        },
    },
};
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .unOfficialJoinedBg {
        background: #333333;
    }
    .commodity-info-module {
            height: px2rem(244);
            background: url(https://b.bdstatic.com/searchbox/image/cmsuploader/20211110/1636527821958034.png) no-repeat;
            background-size: 100%;
            padding: px2rem(46) px2rem(51) 0 px2rem(51);
            position: relative;
            .top-info-lowestIcon {
                position: absolute;
                top: 0;
                left: 0;
                .lowestIcon {
                    width: px2rem(120);
                    height: px2rem(120);
                }
            }
            .top-info {
                display: flex;
                flex-flow: row;
                justify-content: space-around;
                .info-left {
                    flex: 1;
                    .price {
                        color: #FFFFFF;
                        font-size: px2rem(36);
                        line-height: px2rem(48);
                        // margin-bottom: px2rem(30);
                        white-space: nowrap;
                        font-family: PingFangSC-Regular;
                        display: flex;
                        align-items: baseline;
                        .yuan {
                            display: inline-block;
                            margin-left: px2rem(3);
                            font-weight: 500;
                            font-size: px2rem(60);
                            line-height: px2rem(60);
                            font-family: PingFangSC-Medium;
                        }
                        .now-price {
                            display: inline-block;
                            margin-left: px2rem(3);
                            font-weight: 500;
                            font-size: px2rem(90);
                            line-height: px2rem(90);
                            font-family: PingFangSC-Medium;
                        }
                        .original-price {
                            opacity: 0.6;
                            font-family: PingFangSC-Regular;
                            color: #FFFFFF;
                            margin-left: px2rem(6);
                            text-decoration:line-through;
                            margin-bottom: px2rem(-1);
                            line-height: px2rem(48);
                            font-weight: 400;
                        }
                        .tieba-vip--price {
                            font-family: PingFangSC-Medium;
                            font-size: 48px;
                            color: #FFD27A;
                            font-weight: 500;
                            margin-left: 18px;
                        }
                        .vip-icon {
                            width: 108px;
                            height: 36px;
                        }
                    }
                    .discount {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-top: px2rem(14);
                        width: px2rem(609);
                        white-space: nowrap;
                        overflow: hidden;
                        height: px2rem(41);
                        .discount-content {
                            box-sizing: border-box;
                            height: px2rem(41);
                            line-height: px2rem(30);
                            margin-right: px2rem(10);
                            border: px2rem(1) solid #DECD8D;
                            border-radius: px2rem(50);
                            font-size: px2rem(30);
                            padding: px2rem(1) px2rem(12) 0 px2rem(12);
                            font-family: PingFangSC-Regular;
                            color: #DECD8D;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .sales-num {
                        margin-top: px2rem(18);
                        font-size: px2rem(36);
                        line-height: px2rem(36);
                        color: #BBBBBB;
                        font-family: PingFangSC-Regular;
                    }
                }
                .info-right {
                    width: px2rem(480);
                    margin-top: px2rem(45);
                    .count-down-text {
                        font-size: px2rem(36);
                        font-family: PingFangSC-Medium;
                        color: #DCDCDC;
                        display: flex;
                        justify-content: flex-end;
                        margin-bottom: px2rem(6);
                        .light-icon {
                            vertical-align: middle;
                            margin-right: px2rem(3);
                            margin-top: px2rem(5);
                            .lightning {
                            width: px2rem(36);
                            height: px2rem(36);
                            }
                        }
                    }
                    .count-down {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .box {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: px2rem(68);
                            background: rgba(0,0,0,0.6);
                            border-radius: px2rem(20);
                            padding: 0 px2rem(12);
                            .hour {
                                font-weight: 500;
                                font-size: px2rem(48);
                                line-height: px2rem(48);
                                color: #DCDCDC;
                                margin-right: px2rem(3);
                                font-family: PingFangSC-Medium;
                            }
                            .text {
                                display: inline-block;
                                margin-bottom: px2rem(-4);
                                font-size: px2rem(24);
                                color: #FFFFFF;
                                opacity: 0.5;
                                line-height: px2rem(24);
                                font-family: PingFangSC-Medium;
                            }
                        }
                        .colon {
                            margin: 0 px2rem(10);
                            display: flex;
                            justify-content: center;
                            img {
                                width: px2rem(8);
                                height: px2rem(24);
                            }
                        }
                    }
                }
            }
        }
        .bottom-info {
            background-image: linear-gradient(135deg, #4E4E4E 0%, #4D4D4D 100%);
            height: px2rem(78);
            display: flex;
            justify-content: space-between;
            padding: 0 px2rem(51) 0 ;
            .notice {
                color: #DCDCDC;
                font-size: px2rem(36);
                line-height: px2rem(78);
                font-family: PingFangSC-Regular;
            }
        }
        .tibe-vip-guide {
            width: 100%;
            height: px2rem(99);
            padding: 0 px2rem(51);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background-size: cover;
            .icon {
                width: px2rem(51);
                margin-right: px2rem(12);
            }
            .right {
                width: px2rem(23);
                margin-left: auto;
            }
        }
</style>